/* eslint-disable @web-monorepo/no-css-file-imports */
import "extended-proptypes/lib/extend-from-standalone";
import "react-flexbox-layout/lib/styles.css";
import "src/stylesheets/normalize.css";
import "src/stylesheets/transitions.css";
import "src/stylesheets/base.css";
import { Helmet } from "react-helmet";
import { useTranslation } from "@web-monorepo/i18next";
import { useParams } from "react-router-dom";
import IdeasRemoteContainer from "src/pods/ideas/components/IdeasRemoteContainer";

type Params = {
  ideaId: string;
};
export default function IdeaPage() {
  // this tells i18next to load these namespaces
  const { ready } = useTranslation(["dojo.toolkit", "dojo.common"]);
  const params = useParams<Params>();

  return (
    <>
      <Helmet>
        <script src="https://static.classdojo.com/radiant-media-player/js/rmp.min.js" key="rmp" />
      </Helmet>
      {ready && <IdeasRemoteContainer params={params} />}
    </>
  );
}
